<template>
  <div class="wrap-poi-info">
    <div v-if="$store.state.app.isPortrait">
      <div class="wrap-header">
        <div class="nav-back" @click="backFn">
          <i class="el-icon-arrow-left"></i>
        </div>
        地点详情
      </div>
      <div class="wrap-in">
        <!-- poi信息 -->
        <div class="poiInfo">
          <!-- 起点终点选择 -->
          <!-- <div class="text"> 导航目的地 </div> -->
          <div class="name">{{ endPoint.name || '已选择的位置' }}</div>
          <div class="location">{{ buildInfo.buildName }} <span style="color:#fdf13a;">{{ floorMapping[endPoint.floor] }}</span> </div>
          <div class="spend">全程需{{ $moment(navData.time * 1000).format('mm分ss秒') }} {{ navData.distance }}米 </div>
          <!-- </div> -->
          <div class="close-location" @click="closeSimNav">退出模拟导航</div>
        </div>
        <!-- 二维码 -->
        <div class="ercode-block">
          <div class="qrcode2">
            <el-image
              class="img"
              v-if="curPoiQRcode"
              :src="curPoiQRcode"
              :preview-src-list="[curPoiQRcode]"
              @click="handleClickItem"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="info">
            <div class="text1">扫码带你去</div>
            <div class="text2">{{ endPoint.name || '已选择的位置' }}</div>
          </div>
          <div class="text3">提示：使用时请开启手机蓝牙</div>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- poi信息 -->
      <div class="poiInfo">
        <div class="text"> 导航目的地 </div>
        <div class="name">{{ endPoint.name || '已选择的位置' }}</div>
        <div class="location">{{ buildInfo.buildName }} <span style="color:#fdf13a;">{{ floorMapping[endPoint.floor] }}</span> </div>
        <div class="spend">全程需{{ $moment(navData.time * 1000).format('mm分ss秒') }} {{ navData.distance }}米 </div>
      </div>
  
      <!-- 模拟导航 -->
      <div class="closeSimNav" @click="closeSimNav">
        <img src="/images/preloader/icon-close2.png" alt="">
        <span>退出模拟导航</span>
      </div>
  
      <!-- poi二维码 -->
      <div class="qrcode">
        <el-image
          class="img"
          v-if="curPoiQRcode"
          :src="curPoiQRcode"
          :preview-src-list="[curPoiQRcode]"
          @click="handleClickItem"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="info">
          <div class="text1">扫码带你去</div>
          <div class="text2">{{ endPoint.name || '已选择的位置' }}</div>
          <div class="text3">提示：使用时请开启手机蓝牙</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
export default {
  components: {
  },
  props: {

  },
  data () {
    return {
      navData: {
        name: '内科',
        floor: 2,
        time: 31654,
        distance: 123
      }
    };
  },
  computed: {
    // appid
    appid () {
      return this.$store.state.app.appid;
    },
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    },
    // 地图楼层映射
    floorMapping () {
      return this.$store.getters['nav/floorMapping'];
    },
    // 地图当前聚焦楼层
    mapFocusFloor: {
      get () { return this.$store.state.nav.mapFocusFloor; },
      set (val) { this.$store.commit('nav/set_mapFocusFloor', val); }
    },
    // 当前选中的POI二维码
    curPoiQRcode: {
      get () { return this.$store.state.nav.curPoiQRcode; },
      set (val) { this.$store.commit('nav/set_curPoiQRcode', val); }
    },
    // 终点
    endPoint: {
      get () { return this.$store.state.nav.endPoint; },
      set (val) { this.$store.commit('nav/set_endPoint', val); }
    }
  },
  watch: {

  },
  created () {

  },
  mounted () {
  },
  methods: {
    // 后退
    backFn () {
      this.closeSimNav();
    },
    // 关闭el-image遮罩层
    handleClickItem () {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask');
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click();
        });
      });
    },
    async init (data) {
      console.log('poi：', data);
      this.navData.time = data.time;
      this.navData.distance = data.distance;
    },
    // 去这里
    closeSimNav () {
      this.$emit('closeSimNav');
    }
  }
};
</script>

<style scoped lang="scss">
@media (orientation: landscape) {

.wrap-poi-info {
  position: relative;
  height: 100%;
  width: 100%;
  background: url("/images/preloader/rect2.png") no-repeat;
  background-size: 100% 100%;
  padding: 45px 20px 40px 33px;
  box-sizing: border-box;
  .poiInfo{
    padding: 30px 0 60px 0;
    .text{
      font-size: 24px;
      color: $color-white;
      padding: 20px 0 15px 0;
    }
    .name{
      font-size: 24px;
      color: #21feaf;
    }
    .location{
      font-size: 20px;
      color: $color-white;
      padding: 15px 0 0 0;
    }
    .spend{
      font-size: 20px;
      color: $color-white;
      opacity: 0.7;
      padding:30px 0 0 0;
    }
  }
  .closeSimNav{
    width: 100%;
    height: 50px;
    color: $color-white;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: url('/images/preloader/button_04.png') no-repeat;
    background-size: 100% 100%;
    font-size: 18px;
    box-sizing: border-box;
    border-radius: 50px;
    box-shadow: 0px 5px 16px rgba(0,0,0,0.2);
    span{
      margin: 0 0 0 10px;
    }
    img {
      height: 20px;
    }
  }
  .qrcode {
    height: 280px;
    padding: 15px;
    margin: 30px 0 0 0;
    box-sizing: border-box;
    display: flex;
    border: 1px solid #5480a7;
    border-radius: 20px;
    align-items: center;
    ::v-deep .el-icon-circle-close {
      color: #fff;
    }
    .img {
      width: 120px;
      height: 120px;
      border-radius: 20px;
    margin: 0 20px 0 0;
    }
    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      .text1 {
        font-size: 14px;
        color: $color-white;
      }
      .text2 {
        font-size: 20px;
        color: $color-white;
        margin: 15px 0 40px 0;
      }
      .text3 {
        font-size: 14px;
        color: #ff2828;
      }
    }
  }
  .btn-close {
    position: absolute;
    bottom: 40px;
    left: 0;
    right: 0;
    margin: auto;
  }
  @media screen and (max-width: 1446px) {
    .qrcode {
    height: auto;
    padding: 15px;
    margin: 30px 0 0 0;
    box-sizing: border-box;
    display: flex;
    border: 1px solid #5480a7;
    border-radius: 20px;
    align-items: center;
    .img {
      width: 180px;
      border-radius: 5px;
      margin: 0 20px 0 0;
    }
    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      .text1 {
        font-size: 14px;
        color: $color-white;
      }
      .text2 {
        font-size: 20px;
        color: $color-white;
        margin: 15px 0 40px 0;
      }
      .text3 {
        font-size: 14px;
        color: #ff2828;
      }
    }
  }
  }
}
}

@media (orientation: portrait) {
  .wrap-header{
    position:relative;
    height: 140px;
    font-size: 64px;
    color:#fff;
    font-weight:600;
  }
  .nav-back{
    position:absolute;
    left:0;
    top:0;
  }
.wrap-poi-info {
  position: relative;
  width: 100%;
  overflow: hidden;
  background:rgba(0,0,0,.2);
  // background: linear-gradient(-30deg,rgb(50,80,150) 0%, rgb(80,150,180) 100%);
  border-radius: 12px;
  background-size: 100% 100%;
  padding:58px;
  box-sizing: border-box;
  .wrap-in {
    width: 100%;
    height: calc( 100% - 140px);
    display: flex;
    text-align: left;
  }
  .poiInfo{
    position:relative;
    width: 50%;
    margin-right:4%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 44px;
    box-sizing: border-box;
    border-radius: 28px;
    font-size: 44px;
    color: $color-white;
    .name{
      font-size: 54px;
      color: #21feaf;
      margin-bottom: 24px;
    }
    .location{
      font-size: 44px;
      color: $color-white;
      margin-bottom: 12px;
    }
    .close-location{
      width:80%;
      text-align:center;
      display:inline-block;
      border: 1px solid rgba(255, 255, 255, 0.2);
      position:absolute;
      bottom:44px;
      left:50%;
      transform:translateX(-50%);
      font-size: 44px;
      color: $color-white;
      height:114px;
      line-height:114px;
      border-radius:60px;
      background:rgb(30,204,138)
    }
  }

  .ercode-block{
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 44px;
    box-sizing: border-box;
    border-radius: 28px;
    position: relative;
    flex: 1;
    display: flex;
    .img{
      width: 284px;
    }
  }
  .info{
    font-size:46px;
    color: #fff;
    padding-left: 44px;
    padding-top: 44px;
    line-height: 80px;
  }
  .text3{
    position: absolute;
    color: red;
    font-size: 46px;
    bottom: 43px;
    left: 43px;
  }
  .text1 {
    font-size: 2.41vw;
  }
  .text2 {
    font-size: 2.78vw;
  }
  .text3 {
    font-size: 2.04vw;
  }
}
}
</style>
